import ReactSVG from "react-svg"
import { connect } from "react-redux"
import { ReactComponent as TimeIcon } from "../../../images/time-dynamic.svg"
import { ReactComponent as TickIcon } from "../../../images/tick-dynamic.svg"
import { ReactComponent as CalendarIcon } from "../../../images/appointment-only.svg"
import { ReactComponent as MapPin } from "../../../images/map-pin.svg"
import { Button, Divider, Modal, Popup } from "semantic-ui-react"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import moment from "moment/moment"
import { DATE_TIME_FORMAT } from "../../../v1/constants/application"
import { navigationPaths, routerPaths as routePaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router"
import {
  ACTIVE,
  AWAITING_APPROVAL,
  INITIATED_BY_USER,
  WALK_IN
} from "caradvise_shared_components/lib/constants/orders"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons"
import { isMobile } from "react-device-detect"
import { BottomSheet } from "react-spring-bottom-sheet"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import { cancelOrder } from "../../../v1/actions/orders"
import { faCar } from "@fortawesome/pro-regular-svg-icons"
import { deleteCart, fetchActiveOrders } from "../../../v1/actions/user"
import { WALK_IN_ACTIVE } from "../../../shared_component/constants/common"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import { EBAY } from "../../../v1/constants/affiliations"
import { ReactComponent as Tires } from "../../../images/tires.svg"
import { isEbayTireOrder } from "../../../v1/helpers/orderHelpers"
import { getTireShopOrderDetails } from "../../../v1/actions/bookingConfirmation"
import AddToCalendarButton from "../AddToCalendarButton"
import { ReactComponent as CalenderTick } from "../../../images/calender-tick.svg"
import { HOUR, HOURS } from "../../../v1/constants/tires"
import { getApiBaseUrl } from "../../../shared_component/utils/urlUtils"

const NewUpcomingAppointmentCard = ({
  order,
  t,
  history,
  cancelOrder,
  deleteCart,
  fetchActiveOrders,
  getTireShopOrderDetails,
  user
}) => {
  const [showManageAppointment, setShowManageAppointment] = React.useState(false)
  const [showCancelAppointment, setShowCancelAppointment] = React.useState(false)
  const [cancelLoading, setCancelLoading] = React.useState(false)
  const includeStatus = [ACTIVE, WALK_IN, INITIATED_BY_USER, WALK_IN_ACTIVE]
  const [tireOrder, setTireOrder] = React.useState(null)
  const [calenderEvent, setCalenderEvent] = useState()

  const onCancel = () => {
    setShowManageAppointment(false)
    setShowCancelAppointment(true)
  }

  const cancelShopOrder = async () => {
    try {
      const vehicle_id = order.vehicle_id
      setCancelLoading(true)
      await cancelOrder(order.id)
      await fetchActiveOrders()
      await deleteCart(vehicle_id, false)
      setShowCancelAppointment(false)
    } catch (error) {
      console.log(error)
    }
    setCancelLoading(false)
  }

  const onReschedule = () => history.push(routePaths.appointment)

  useEffect(() => {
    async function fetchTireOrder() {
      if (order?.is_tire_order && order?.id) {
        const res = await getTireShopOrderDetails(user, order.tire_dependent_order_id)
        if (res.result) {
          setTireOrder(res.result.tire_shop_order)
        }
      }
    }
    fetchTireOrder()
    buildEvent()
  }, [order])

  const tire = tireOrder?.tire_orders?.[0]

  const buildEvent = () => {
    const shop = order.shop
    const order_services = order.order_services || []
    if (shop) {
      const start = moment(order.appointment_datetime)
      const end = start.clone().add(1, HOUR)
      const duration = end.diff(start, HOURS)
      const orderServices = order_services
        .map(function (service, index) {
          return `${index + 1}. ${service.name}`
        })
        .join("\n")
      const description = `${shop.name} ${shop.address_line1} ${shop.city}, ${shop.state} ${shop.zip}\\n\\nServices:\\n${orderServices}\\n\\nCarAdvise Support:\\nsupport@caradvise.com\\n(844) 923-8473`
      const baseURL = getApiBaseUrl()
      let eventFormed = {
        title: `CarAdvise Appointment - ${shop.name}`,
        startDate: start.format(DATE_TIME_FORMAT.YYYY_MM_DD),
        startTime: start.format(DATE_TIME_FORMAT.HH_M),
        endDate: end.format(DATE_TIME_FORMAT.YYYY_MM_DD),
        endTime: end.format(DATE_TIME_FORMAT.HH_M),
        timezone: shop.time_zone,
        duration: `${duration}`,
        description: description,
        location: `${shop.address_line1} ${shop.city}, ${shop.state} ${shop.zip}`,
        iCalFileName: `CarAdvise Appointment - ${shop.name}`,
        linkToOrder: `${baseURL}/#/shop_orders/${order?.id}/review`
      }
      setCalenderEvent(eventFormed)
    }
  }

  const GetSomeHelpBtn = () => (
    <>
      <Button
        className="btn details-btn"
        onClick={() => history.push(navigationPaths.shopInstructions(order.id))}
      >
        Get shop help
      </Button>
      {isMobile && includeStatus.includes(order.status) && !order?.is_tire_order && (
        <Button
          className="btn reschedule-btn"
          onClick={() => {
            setShowManageAppointment(true)
          }}
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </Button>
      )}
      {!isMobile && includeStatus.includes(order.status) && !order?.is_tire_order && (
        <Popup
          basic
          trigger={
            <Button className="btn reschedule-btn">
              <FontAwesomeIcon icon={faEllipsisV} />
            </Button>
          }
          content={
            <ManageYourAppointmentCard
              popup={true}
              onCancel={onCancel}
              t={t}
              onReschedule={onReschedule}
              order={order}
            />
          }
          on="click"
          position="bottom right"
          style={{ zIndex: 9999 }}
        />
      )}
    </>
  )

  return (
    <div className="upcoming-appointment-card">
      <div className="title">
        <div className="icon-text">
          <ReactSVG src="/images/calendar-icon.svg" className="calendar-icon" />
          Upcoming service
        </div>
      </div>
      <div className="content">
        <div className="service-section">
          <div>
            <div className="pill-row">
              <PillBadge color="#EFEFEF">
                <p className="services">
                  {order?.order_services.length} {t("services")}
                </p>
              </PillBadge>
              <PillBadge>
                <div
                  className={
                    "status-section" + (order.status === AWAITING_APPROVAL ? " warning" : "")
                  }
                >
                  {order.status === AWAITING_APPROVAL ? <TimeIcon /> : <TickIcon />}
                  <p>{t(`orderStatus:${order.status}`)}</p>
                </div>
              </PillBadge>
            </div>
          </div>
          {order.vehicle && (
            <div className="date-row">
              <FontAwesomeIcon icon={faCar} />
              <p>{order.vehicle.name}</p>
            </div>
          )}
          {order.is_tire_order && tireOrder && tire && (
            <div className="date-row">
              <Tires style={{ width: "16px", height: "16px" }} />
              <div className="text-start">
                <p>Tires: {tire?.quantity} </p>
                <p className="text-normal tire-text-wrap">
                  {tire?.brand} {tire?.tire_model} {tire?.tire_details}
                </p>
              </div>
            </div>
          )}
          {isEbayTireOrder(order) && (
            <div className="date-row">
              <Tires style={{ width: "16px", height: "16px" }} />
              <div className="text-start">
                <p>Tires from eBay:</p>
                <p className="text-normal tire-text-wrap">{order.tire_details}</p>
              </div>
            </div>
          )}
          <div className="date-row" style={{ justifyContent: "space-between" }}>
            <div className="date-row">
              <CalendarIcon className="calendar-icon" />
              <p>{showDateTime(order, t)}</p>
            </div>
            <div
              className="action-row desktop-hidden"
              style={{ display: "flex", justifyContent: "end", maxWidth: "300px" }}
            >
              {GetSomeHelpBtn()}
            </div>
          </div>
          {order.shop && (
            <div className="date-row">
              <div className="date-row">
                <MapPin className="calendar-icon" />
                <div style={{ textAlign: "start" }}>
                  <p>{order.shop?.name},</p>
                  <p className="text-normal">{order.shop?.address_line1},</p>
                  <p className="text-normal">{`${order.shop?.city}, ${order.shop?.state} - ${order.shop?.zip}`}</p>
                </div>
              </div>
              <div className="add-to-calendar-container " style={{ alignSelf: "center" }}>
                <AddToCalendarButton {...calenderEvent}>
                  <div className="add-to-calendar-btn" style={{ padding: "5px" }}>
                    <CalenderTick />
                    <p className="text-small-dark">Add to Calendar</p>
                  </div>
                </AddToCalendarButton>
              </div>
            </div>
          )}
        </div>
        <Divider className="divider mobile-only" />
        <div
          className={
            "action-row mobile-only " +
            (!includeStatus.includes(order.status) ? "justify-center" : "")
          }
        >
          {GetSomeHelpBtn()}
        </div>
      </div>
      {isMobile ? (
        <BottomSheet
          open={showManageAppointment}
          onDismiss={() => setShowManageAppointment(false)}
          snapPoints={({ minHeight }) => minHeight}
          draggable={false}
          maxHeight={1000}
        >
          <ManageYourAppointmentCard
            close={() => setShowManageAppointment(false)}
            onCancel={onCancel}
            t={t}
            onReschedule={onReschedule}
            order={order}
          />
        </BottomSheet>
      ) : (
        <Modal open={showManageAppointment} className="cancel-appointment-modal">
          <Modal.Content>
            <FontAwesomeIcon
              icon={faClose}
              onClick={() => setShowManageAppointment(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "20px",
                height: "20px"
              }}
            />
            <ManageYourAppointmentCard
              popup={true}
              onCancel={onCancel}
              t={t}
              onReschedule={onReschedule}
              order={order}
            />
          </Modal.Content>
        </Modal>
      )}
      <Modal open={showCancelAppointment} className="cancel-appointment-modal">
        <Modal.Content>
          <div className="cancel-appointment">
            <div className="header">
              <p>{t("doYouWantToCancel")}</p>
              <FontAwesomeIcon
                icon={faClose}
                onClick={() => setShowCancelAppointment(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  width: "20px",
                  height: "20px"
                }}
              />
            </div>

            <p className="subtext">{t("needDifferentTime")}</p>

            <div className="actions">
              <Button
                className="btn reschedule-btn"
                onClick={() => history.push(routePaths.appointment)}
              >
                {t("reschedule")}
              </Button>
              <Button className="btn details-btn" onClick={cancelShopOrder} loading={cancelLoading}>
                {t("cancelAppointment")}
              </Button>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default withRouter(
  connect(mapStateToProps, { cancelOrder, deleteCart, fetchActiveOrders, getTireShopOrderDetails })(
    withTranslation(["upcomingAppointment"])(NewUpcomingAppointmentCard)
  )
)

export const PillBadge = ({ children, color }) => {
  return (
    <div className="pill-badge" style={{ backgroundColor: color }}>
      {children}
    </div>
  )
}

const ManageYourAppointmentCard = ({ popup, close, onReschedule, onCancel, t, order }) => {
  return (
    <div className="manage-appointment-card">
      <div className={"manage-appointment-card-header" + (popup ? " justify-center" : "")}>
        <p className="manage-appointment-card-title">Manage your service</p>
        {!popup && <FontAwesomeIcon icon={faClose} onClick={close} />}
      </div>

      <div className="manage-appointment-card-body">
        <div className="manage-option" onClick={onReschedule}>
          <CalendarIcon className="calendar-icon" />
          <p>{t("reschedule")}</p>
        </div>
        {!isEbayTireOrder(order) && (
          <div>
            <Divider />
            <div className="manage-option cancel" onClick={onCancel}>
              <FontAwesomeIcon icon={faClose} />
              <p>{t("cancelAppointment")}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export const showDateTime = (cart, t) => {
  return (
    <>
      <span>
        {cart.appointment_datetime &&
          moment(cart.appointment_datetime)
            .parseZone()
            .format(DATE_TIME_FORMAT.APPOINTMENT_DATETIME_DATE_PREVIEW)}
      </span>
      {!cart.is_walk_in && (
        <>
          <span>
            {cart.appointment_time_pretty.includes("3:00 AM")
              ? ""
              : cart.appointment_time_pretty && " @ "}
          </span>
          {cart.appointment_time_pretty.includes("3:00 AM") ? (
            ""
          ) : (
            <span>
              {cart.appointment_datetime &&
                moment(cart.appointment_datetime)
                  .parseZone()
                  .format(DATE_TIME_FORMAT.APPOINTMENT_DATETIME_TIME_PREVIEW)}
            </span>
          )}
        </>
      )}
    </>
  )
}
